import React from 'react';
import SEOHead from '@/components/marketing/SEOHead';
import PageHeader from '@/components/marketing/PageHeader';
import CTASection from '@/components/marketing/CTASection';
import FAQAccordion from '@/components/marketing/FAQAccordion';
import { FULL_FAQ_GROUPS } from '@/data/site-content';
import { breadcrumbJsonLd, graph } from '@/lib/jsonld';

export default function FAQPage() {
  const allItems = FULL_FAQ_GROUPS.flatMap((g) => g.items);
  const faqNode = {
    '@type': 'FAQPage',
    mainEntity: allItems.map((it) => ({
      '@type': 'Question', name: it.q,
      acceptedAnswer: { '@type': 'Answer', text: it.a },
    })),
  };
  const jsonLd = graph(
    breadcrumbJsonLd([
      { label: 'Home', path: '/' },
      { label: 'FAQ' },
    ]),
    faqNode,
  );
  return (
    <>
      <SEOHead path="/faq" jsonLd={jsonLd} />
      <PageHeader breadcrumbs={[{ label: 'FAQ' }]} eyebrow="Help center" title="Frequently asked questions" subtitle="Quick answers about how Ads Dashbound works — from application to launch and beyond." />
      <section className="bg-[#F5F7FB]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-10">
          {FULL_FAQ_GROUPS.map((g) => (
            <div key={g.title} className="rounded-2xl bg-white border border-slate-900/10 px-5 sm:px-7">
              <h2 className="font-display text-xl font-bold text-slate-900 pt-6 pb-2">{g.title}</h2>
              <FAQAccordion items={g.items} idPrefix={`faq-${g.title}`} />
            </div>
          ))}
        </div>
      </section>
      <CTASection />
    </>
  );
}
